import session from "./session.store";
import sideMenu from "./sidemenu.store";
import forms from "./forms.store";
import modals from "./modals.store";
import fields from "./fields.store";

export default {
    modules: {
        session,
        sideMenu,
        forms,
        modals,
        fields,
    }
};